document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-container');
  const mobileMenu = document.querySelector('.header-mobile-menu');
  const burgerBtn = document.querySelector('.header-burger');
  const closeBtn = document.querySelector('.header-mobile-close');
  const navLinks = document.querySelectorAll('.header-mobile-nav .header-nav-link');

  // Логіка зміни кольору хедера при скролі
  function checkScroll() {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  // Викликаємо відразу (на випадок оновлення сторінки вже внизу) та при скролі
  window.addEventListener('scroll', checkScroll);
  checkScroll();

  // Відкриття меню
  burgerBtn.addEventListener('click', function () {
    mobileMenu.classList.add('active');
    document.body.classList.add('noscroll');
  });

  // Закриття меню
  const closeMenu = () => {
    mobileMenu.classList.remove('active');
    document.body.classList.remove('noscroll');
  };

  closeBtn.addEventListener('click', closeMenu);

  // Кліки по посиланнях
  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      navLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      closeMenu(); // Закриваємо меню та вмикаємо скрол

      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const section = document.querySelector(href);
        if (section) {
          e.preventDefault(); // Запобігаємо різкому стрибку
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});
